// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2zJbv","row":"ProcedureTreatmentSummary_row__2vgKH"};